import TrackingData from "./TrackingData";

/**
 * @class
 * @memberOf P3.tracking
 */
export default class TrackingDataGoogleEvent extends TrackingData {
    /**
     * @param {string} category
     * @param {string} action
     * @param {string} [label]
     * @param {number} [value]
     * @param
     */
    constructor(category, action, label, value) {
        super();

        this.category = category;
        this.action = action;
        this.label = label;
        this.value = value;
    }
}